export var Name = 'update-donation';
export var UpdateDonationEvent = Name;